import client from '../api/client.js'

export const fetchPaymentRequest = async (paymentId, options = {}) => {
  const response = await client.get(`/payments/${paymentId}`, {
    ...(options?.signal ? { signal: options.signal } : {}),
  })
  return response?.data
}

export const capturePaymentRequest = async (paymentId, payload = {}, options = {}) => {
  const response = await client.post(`/payments/${paymentId}/capture`, payload, {
    ...(options?.signal ? { signal: options.signal } : {}),
  })
  return response?.data
}

export const refundPaymentRequest = async (paymentId, payload = {}, options = {}) => {
  const response = await client.post(`/payments/${paymentId}/refund`, payload, {
    ...(options?.signal ? { signal: options.signal } : {}),
  })
  return response?.data
}

export const reconcilePaymentsRequest = async (payload = {}, options = {}) => {
  const response = await client.post('/payments/webhook/reconcile', payload, {
    ...(options?.signal ? { signal: options.signal } : {}),
  })
  return response?.data
}

export const fetchPaymentOperationsRequest = async (params = {}, options = {}) => {
  const response = await client.get('/payments/operations', {
    params,
    ...(options?.signal ? { signal: options.signal } : {}),
  })
  return response?.data
}

